window.onload=function(){
  $('.animate-btn-fill').hover(
              function() {
                $(this).css({
                    background:"transparent"
                })
                  $(this).find(".btn-fill").css({
                        "transform":"translateY(0)"
                  })
              },
            function() {
                $(this).css({
                    background:""
                })
                $(this).find(".btn-fill").css({
                    "transform":"translate3d(0,-76%,0)"
                })
              }
          )
}